// Port of whatsapp-console-frontend `src/helpers/mediaHelper.js`
// `replaceDomainInData`: S3 bucket / old CDN hosts become the CloudFront host
// the rest of the platform serves media from. Applies to every string inside
// strings, arrays and plain objects.

const DOMAIN_MAP: Array<[string, string]> = [
  [
    'https://whatsapp-media-library.s3.ap-south-1.amazonaws.com',
    'https://d3jt6ku4g6z5l8.cloudfront.net',
  ],
  [
    'https://whatsapp-media-incoming.s3.ap-south-1.amazonaws.com',
    'https://dnw6l5n94jgqf.cloudfront.net',
  ],
  ['https://d2npdtryso7wvr.cloudfront.net', 'https://dnw6l5n94jgqf.cloudfront.net'],
  [
    'https://whatsapp-media-library-1.s3.ap-south-1.amazonaws.com',
    'https://dc4ardkuedwlq.cloudfront.net',
  ],
  [
    'https://whatsapp-media-library-stg.s3.ap-south-1.amazonaws.com',
    'https://dwbb9b4enii6a.cloudfront.net',
  ],
  [
    'https://whatsapp-media-library-pre-stg.s3.ap-south-1.amazonaws.com',
    'https://d1fviw7lxswn81.cloudfront.net',
  ],
  ['https://whatsapp-ai-assets-stg.s3.amazonaws.com', 'https://d2rc167eibdk5g.cloudfront.net'],
  ['https://whatsapp-ai-assets.s3.amazonaws.com', 'https://d2l0behpew8af1.cloudfront.net'],
];

export const replaceDomainInData = <T>(data: T): T => {
  if (typeof data === 'string') {
    let url: string = data;
    DOMAIN_MAP.forEach(([from, to]) => {
      if (url.includes(from)) {
        url = url.replace(from, to);
      }
    });
    return url as unknown as T;
  }
  if (Array.isArray(data)) {
    return data.map((item) => replaceDomainInData(item)) as unknown as T;
  }
  if (data && typeof data === 'object') {
    const next: Record<string, unknown> = {};
    Object.keys(data as Record<string, unknown>).forEach((key) => {
      next[key] = replaceDomainInData((data as Record<string, unknown>)[key]);
    });
    return next as T;
  }
  return data;
};
